import type { AppRoute } from '@/lib/routing/routing.types'

const routeModules = import.meta.glob<{ default: AppRoute[] }>('../../features/**/routes.ts', {
  eager: true,
})

/**
 * Collects and concatenates the routes of all features.
 *
 * Rules:
 * - Each module MUST export `default` with an `AppRoute[]`.
 * - No extra ordering is applied here; parent→children hierarchy lives in each feature file.
 */
export function collectFeatureRoutes(): AppRoute[] {
  const acc: AppRoute[] = []

  for (const [path, mod] of Object.entries(routeModules)) {
    const routes = mod.default

    if (!Array.isArray(routes)) {
      throw new Error(
        `[routing.collector] Invalid export in "${path}" — must export default AppRoute[]`,
      )
    }

    acc.push(...routes)
  }

  return acc
}
